import React from 'react'

import { Divider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import FeeRow from './FeeRow'

function formatCurrency(amount) {
  return `$${amount.toFixed(2)}`
}

function FeeBreakdown({
  remainingMonths,
  monthlyRate,
  totalRemaining,
  cancelFee,
  accessUntilFormatted,
  locale = 'en',
}) {
  const translate = (key) => I18n.t(
    `subscription_management.cancel_modal.${key}`,
    { ns: 'rails', lng: locale }
  )

  return (
    <>
      <div className="cancel-subscription-modal__fee-breakdown">
        <FeeRow
          label={`${translate('remaining_months')}:`}
          value={remainingMonths}

        />
        <FeeRow
          label={`${translate('monthly_rate')}:`}
          value={formatCurrency(monthlyRate)}

        />
        <FeeRow
          label={`${translate('total_remaining')}:`}
          value={
            <>
              {remainingMonths} &times;{' '}
              {formatCurrency(monthlyRate)} ={' '}
              {formatCurrency(totalRemaining)}
            </>
          }

        />
        <FeeRow
          label={`${translate('cancellation_fee_percent')}:`}
          value={formatCurrency(cancelFee)}
          variant="danger"

        />
        <FeeRow
          label={`${translate('calculated_active_period')}:`}
          value={accessUntilFormatted}

        />
      </div>
      <Divider />
      <div className="cancel-subscription-modal__fee-summary">
        <FeeRow
          label={translate('contract_commitment_value')}
          value={formatCurrency(totalRemaining)}
          layout="summary"

        />
        <FeeRow
          label={translate('cancellation_fee_summary')}
          value={formatCurrency(cancelFee)}
          layout="summary"
          variant="danger"

        />
      </div>
      <Divider />
    </>
  )
}

FeeBreakdown.propTypes = {
  remainingMonths: number.isRequired,
  monthlyRate: number.isRequired,
  totalRemaining: number.isRequired,
  cancelFee: number.isRequired,
  accessUntilFormatted: string.isRequired,
  locale: string,
}

export default FeeBreakdown
